// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3zkFU","header":"PatientBlock_header__3V1KX","label":"PatientBlock_label__1qvgv","option":"PatientBlock_option__1q3se"};